import { render, staticRenderFns } from "./RepresentativeCreate.vue?vue&type=template&id=4b56c240&"
import script from "./RepresentativeCreate.vue?vue&type=script&lang=ts&"
export * from "./RepresentativeCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports